export const lang = {
    customer : {
        home :{
            find_btn: 'Find Your Genrun',
            find_probtn: 'Find Your GenPro',
            choose_services : 'Choose Your Services',
            banner_title: 'Find the best Run Errand for your needs',
            banner_protitle: 'Find the best Service Provider for your needs',
            popular_services : 'Popular Services',
            load_more_services: 'Load More Services',
            asktocall : 'Ask to Call',
        },
        trans: {
            genruncounterfee : 'GenRun Counter Fee',
            text_message : 'GenMessage',
            counter_offer:'Counter-offer',
        }
    },
    common: {
        title:'Bus Booking',
        status_option:[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
        ],
        gender_option: [
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' }
        ],
		image_size_option: [
            { value: '250x250', label: '250x250' },
			{ value: '350x350', label: '350x350' },
            { value: '520x520', label: '520X520' }
        ],
        coming_source :[
            { value: '0', label: 'Select' },
            { value: 'friends', label: 'Friends' },
            { value: 'facebook', label: 'Facebook' },
            { value: 'instagram', label: 'Instagram' },
            { value: 'messaging apps', label: 'Messaging Apps' },
            { value: 'website', label: 'Website' },
            { value: 'flyers', label: 'Flyers' },
            { value: 'sms', label: 'Sms' },
            { value: 'newspaper', label: 'Newspapers' },
            { value: 'others', label: 'Others' }
        ],
        expired: 'Expired',
        more_info: 'More Info',
        no_trans:'No transaction found',
        enter_amount : 'Enter Amount',
        send : 'Send',
        accept : 'Accept',
        gentrun: 'GenRun',
        genpro: 'GenPro',
        genproperty: 'GenProperty',
    },
    genrun : {
        cust_lead: {
            transaction_id: 'Transaction ID',
        }
    },
    info: {
        pro: {
            title:'How GenPro works?',
            heading:'Easy comparison for different professional service provider',
            slug:'how-it-works-genpro-mq',
            link:'https://geniehut.com/pro-detail'
        },
        run: {
            title:'How GenRun works?',
            heading:'Get a part timer (GenRun) to run errand for you',
            slug:'how-it-works-genrun-mq',
            link:''
        },
        property: {
            title:'How GenProperty works?',
            heading:'Advanced search engine retrieving desired results from different property search websites',
            slug:'welcome-to-genproperty-mq',
            link:''
        },
        ads: {
            title:'How GenAds works?',
            heading:'Barter GH points or items with other community users.',
            slug:'how-it-works-redeem-mq',
            link:''
        },
        how_geniehut_works_video: {
            title:'How Geniehut works?',
            heading:'',
            slug:'homepage-video-mq',
            link:''
        },
        point_summary: {
            title:'GH points summary',
            heading:'',
            slug:'gh-points-summary-popup-mq',
            link:''
        }
    },
    enable: {
         GP: {
            title:'Register as our service partners?',
            content:'Add services/listings and update the details to get 300 GH Points!',   
        },
        GR: {
            title:'Register as our service partners?',
            content:'Add services/listings and update the details to get 300 GH Points!',
        }
    },
    search: {
        subtitle: 'Enter the Subtitle',
    }
};


